class WWGallery {

    constructor(gallery){

        this.gallery = gallery;

        this.track = gallery.querySelector(".ww-gallery__track");

        this.slides = [...gallery.querySelectorAll(".ww-gallery__slide")];

        this.thumbs = [...gallery.querySelectorAll(".ww-thumb")];

        this.dots = [...gallery.querySelectorAll(".ww-gallery__dot")];

        this.prev = gallery.querySelector(".ww-gallery__arrow--prev");

        this.next = gallery.querySelector(".ww-gallery__arrow--next");

        this.current = 0;

        this.startX = 0;

        this.endX = 0;

        this.total = this.slides.length;
        const db = JSON.parse(
    document.getElementById("ww-media-database").textContent
);

this.media = db.media;
this.variants = db.variants;

this.buildVariantGroups();
this.bindEvents();
this.initSelectedVariant();

// Fallback for products without variant-specific media
if (
    !this.variants.some(v => v.featured_media)
) {
    this.current = 0;
    this.update();
}
    }
    
update() {

    const visibleSlides = this.slides.filter(
        slide => slide.style.display !== "none"
    );
    this.slides.forEach(slide => {
    slide.style.position = "absolute";
});

if (visibleSlides.length) {
    visibleSlides[0].style.position = "relative";
}

    const visibleThumbs = this.thumbs.filter(
        thumb => thumb.style.display !== "none"
    );

    if (!visibleSlides.length) return;

    if (this.current >= visibleSlides.length) {
        this.current = 0;
    }

    this.slides.forEach(slide => {
        slide.style.transform = "translateX(100%)";
    });

    this.slides.forEach(slide => {

    slide.style.opacity = "0";
    slide.style.zIndex = "0";

});

    visibleSlides.forEach((slide, index) => {

    slide.style.transform =
        `translateX(${(index - this.current) * 100}%)`;

    slide.style.zIndex =
        index === this.current ? "2" : "1";

    slide.style.opacity =
        index === this.current ? "1" : "0";

});

    visibleThumbs.forEach((thumb, index) => {
        thumb.classList.toggle(
            "is-active",
            index === this.current
        );
    });

}


go(index){

    const totalVisible =
        this.slides.filter(
            slide => slide.style.display !== "none"
        ).length;

    if(index < 0)
        index = totalVisible - 1;

    if(index >= totalVisible)
        index = 0;

    this.current = index;

    this.update();

}

    nextSlide(){

        this.go(this.current+1);

    }

prevSlide() {

    this.go(this.current - 1);

}
buildVariantGroups() {

    this.variantGroups = {};

    const featuredIds = this.variants
        .map(v => Number(v.featured_media))
        .filter(Boolean);

    const starts = [...new Set(featuredIds)];

    starts.sort((a, b) => {

        return (
            this.media.find(m => m.id === a).position -
            this.media.find(m => m.id === b).position
        );
        

    });

    starts.forEach((startId, index) => {

        const startPos =
            this.media.find(m => m.id === startId).position;

        const endPos =
    index < starts.length - 1
        ? this.media.find(m => m.id === starts[index + 1]).position
        : this.media.length + 1;

this.variantGroups[startId] = this.media
    .filter(m => m.position >= startPos && m.position < endPos)
    .sort((a, b) => a.position - b.position)
    .map(m => m.id);

    });

}
filterByVariant(featuredMediaId) {

    featuredMediaId = Number(featuredMediaId);

    const visibleMedia =
        this.variantGroups[featuredMediaId] || [];

    this.slides.forEach(slide => {

        slide.style.display =
            visibleMedia.includes(Number(slide.dataset.mediaId))
                ? ""
                : "none";

    });

    this.thumbs.forEach(thumb => {

        thumb.style.display =
            visibleMedia.includes(Number(thumb.dataset.mediaId))
                ? ""
                : "none";

        thumb.classList.remove("is-active");

    });

    this.current = 0;

    this.update();

}
initSelectedVariant() {

    const selectedOptions = [
        ...document.querySelectorAll(
            "variant-selects input[type='radio']:checked"
        )
    ].map(input => input.value);

    const variant = this.variants.find(v => {

        return (!v.option1 || v.option1 === selectedOptions[0]) &&
               (!v.option2 || v.option2 === selectedOptions[1]) &&
               (!v.option3 || v.option3 === selectedOptions[2]);

    });

    if (variant && variant.featured_media) {

    this.filterByVariant(variant.featured_media);

} else {

    this.update();

}

}

       bindEvents() {

    /* ---------- Thumbnails ---------- */

this.thumbs.forEach((thumb) => {

    thumb.addEventListener("click", () => {

        const visibleThumbs = this.thumbs.filter(
            t => t.style.display !== "none"
        );

        const index = visibleThumbs.indexOf(thumb);

        if (index < 0) return;

        this.current = index;

        this.update();

    });

});

    /* ---------- Dots ---------- */

    this.dots.forEach((dot,index)=>{

        dot.addEventListener("click",()=>{

            this.go(index);

        });

    });

    /* ---------- Arrows ---------- */

    if(this.prev){

        this.prev.addEventListener("click",()=>{

            this.prevSlide();

        });

    }

    if(this.next){

        this.next.addEventListener("click",()=>{

            this.nextSlide();

        });

    }

    /* ---------- Swipe ---------- */

    this.track.addEventListener("touchstart",(e)=>{

        this.startX = e.touches[0].clientX;

    },{passive:true});

    this.track.addEventListener("touchend",(e)=>{

        this.endX = e.changedTouches[0].clientX;

        const distance = this.startX - this.endX;

        if(Math.abs(distance) < 40){

            return;

        }

        if(distance > 0){

            this.nextSlide();

        }else{

            this.prevSlide();

        }

    },{passive:true});

    /* ---------- Keyboard ---------- */

    this.gallery.addEventListener("mouseenter",()=>{

        this.active = true;

    });

    this.gallery.addEventListener("mouseleave",()=>{

        this.active = false;

    });

    document.addEventListener("keydown",(e)=>{

        if(!this.active){

            return;

        }

        if(e.key==="ArrowRight"){

            this.nextSlide();

        }

        if(e.key==="ArrowLeft"){

            this.prevSlide();

        }

    });

}

}
/* ===================================================== */

document.addEventListener("DOMContentLoaded",()=>{

    document.querySelectorAll(".ww-gallery").forEach((gallery)=>{

        window.wwGallery = new WWGallery(gallery);

    });

});